import { render, staticRenderFns } from "./AddWebhook.vue?vue&type=template&id=60248a3e"
import script from "./AddWebhook.vue?vue&type=script&lang=js"
export * from "./AddWebhook.vue?vue&type=script&lang=js"
import style0 from "./AddWebhook.vue?vue&type=style&index=0&id=60248a3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports